import Big from 'bignumber.js'

export const _times = (...args) => {
  let a = args.shift()
  if (a === null || a === undefined) a = 0
  return args.reduce((acc, x) => {
    if (x === null || x === undefined) return acc
    return (new Big(acc.toString())).times(new Big(x.toString())).toNumber()
  }, a)
}

export const _plus = (...args) => {
  let a = args.shift()
  if (a === null || a === undefined) a = 0
  return args.reduce((acc, x) => {
    if (x === null || x === undefined) return acc
    return (new Big(acc.toString())).plus(new Big(x.toString())).toNumber()
  }, a)
}

export const _minus = (...args) => {
  let a = args.shift()
  if (a === null || a === undefined) a = 0
  return args.reduce((acc, x) => {
    if (x === null || x === undefined) return acc
    return (new Big(acc.toString())).minus(new Big(x.toString())).toNumber()
  }, a)
}

export const _div = (...args) => {
  let a = args.shift()
  if (a === null || a === undefined) a = 0
  return args.reduce((acc, x) => {
    if (x === null || x === undefined) return acc
    return (new Big(acc.toString())).div(new Big(x.toString())).toNumber()
  }, a)
}

export const _percentage = (p) => {
  if (p === null || p === undefined) return 0
  return (new Big(p.toString())).div(100).toNumber()
}

export const _isGreater = (a, b) => {
  if (a === null || a === undefined) return false
  else if (b === null || b === undefined) return false
  return (new Big(a.toString())).gt(new Big(b.toString()))
}

export const _isGreaterOrEqual = (a, b) => {
  if (a === null || a === undefined) return false
  else if (b === null || b === undefined) return false
  return (new Big(a.toString())).gte(new Big(b.toString()))
}

export const _isLess = (a, b) => {
  if (a === null || a === undefined) return false
  else if (b === null || b === undefined) return false
  return (new Big(a.toString())).lt(new Big(b.toString()))
}

export const _isLessOrEqual = (a, b) => {
  if (a === null || a === undefined) return false
  else if (b === null || b === undefined) return false
  return (new Big(a.toString())).lte(new Big(b.toString()))
}

export const _toFixed = (a, d) => {
  if (a === null || a === undefined) return 0
  else if (d === null || d === undefined) return a
  return (new Big((new Big(a.toString())).toFixed(d))).toNumber()
}

export const _countDecimals = (value) => { 
  return (value % 1) !== 0 ? value.toString().split(".")[1].length : 0
}

export const _lastDecimal = (value) => {
  return parseInt(value.toString()[value.toString().length - 1])
}

export default Big
